import React from "react";
import styled from "@emotion/styled";
import { Box, Stack, Typography } from "@mui/material";
import { TransLanguage } from "components";
import { useTranslation } from "react-i18next";
import { NetworkFailedIcon } from "components/icons";
import { useNetworkStatus, useServerMode } from "hooks";
import { LangConstant } from "const";

const NetworkFailed = () => {
  const { t: getLabel } = useTranslation(LangConstant.NS_CHECK_NETWORK);
  const { isOnline, serverStatuses } = useNetworkStatus();
  const { selectedBranch } = useServerMode();

  return (
    <Box px={2}>
      {!(serverStatuses[selectedBranch.id] !== false && isOnline) && (
        <UpgradeAppBox>
          <NetworkFailedIcon />
          <Typography component="div">
            <TransLanguage i18nKey={getLabel("NETWORK_FAILED")} />
          </Typography>
          <div></div>
        </UpgradeAppBox>
      )}
    </Box>
  );
};

export default NetworkFailed;

const UpgradeAppBox = styled(Stack)(() => ({
  flexDirection: "row",
  justifyContent: "space-between",
  alignItems: "center",
  backgroundColor: "#FFB800",
  borderRadius: 10,
  padding: "7px 10px",
  cursor: "pointer",

  "& *": {
    color: "white",
  },
}));
